module.exports = __webpack_public_path__ + "static/media/logoWinterball.faf280a4.png";